import { CREATE_OFFER_SCHEME_API_URL } from '../components/Shared/constant';
import axios from 'axios';

const CreateOfferSchemeAPI = (payload, accessToken) => {
  const responce = axios
    .post(CREATE_OFFER_SCHEME_API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then(function (result) {
      return {
        ...result.data,
        status: 200,
      };
    })
    .catch(function (result) {
      return {
        ...result?.response?.data,
        status: result?.response?.status,
      };
    });
  return responce;
}

export default CreateOfferSchemeAPI
